import { W as WuiGraphIcon$1, d as defineCustomElement$1 } from './p-DO1rVB1V.js';

const WuiGraphIcon = WuiGraphIcon$1;
const defineCustomElement = defineCustomElement$1;

export { WuiGraphIcon, defineCustomElement };
